export default function (locale, referralCode) {
  return {
    query: `query ($locale: String!, $referralCode: String!) {
      dynamicBlock(filter: {locale: {eq: $locale}, referralCode: {eq: $referralCode}}) {
        content
      }
    }`,
    variables: {
      locale,
      referralCode,
    },
  }
}
